module.exports = __webpack_public_path__ + "img/character01_static.f5008caa.png";